'use strict';

const { h, Component } = require('phy');
const { hydrate } = require('@grpn/hydration');
const { Translate, WithI18n } = require('@grpn/preact-l10n');

const { isEmailValid } = require('../../support/email-helper');

class EmailSubscriptionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      subscribed: false,
      errors: {
        subscription: false,
        email: false,
        terms: false,
      },
      showLoading: false,
      areTermsAccepted: false,
    };
  }

  keyUpHandler(event) {
    const { value: email } = event.target;
    const { state: newState } = this;
    newState.email = email;
    if (this.state.subscribed) {
      newState.subscribed = false;
    }

    if (this.state.errors.email) {
      newState.errors.email = !isEmailValid(email);
    }

    this.setState(newState);
  }

  submit(event) {
    event.preventDefault();

    const { email } = this.state;

    const { areTermsAccepted } = this.state;
    const validEmail = isEmailValid(email);

    if (!areTermsAccepted || !validEmail) {
      const newSate = {
        subscribed: false,
        errors: {
          email: !validEmail,
          terms: !areTermsAccepted,
        },
      };

      this.setState(newSate);
      return;
    }

    this.setState({ showLoading: true });

    const { csrfToken, routes } = this.props;
    const payload = {
      email,
    };

    fetch(routes.email_subscription.main, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'csrf-token': csrfToken,
      },
      body: JSON.stringify(payload),
    }).then(res => {
      const newState = res.ok
        ? {
            subscribed: true,
            errors: {
              subscription: false,
            },
            showLoading: false,
          }
        : {
            errors: {
              subscription: true,
            },
            showLoading: false,
          };
      this.setState(newState);
    });
  }

  getCTAText() {
    if (this.state.showLoading) {
      return '';
    }

    return `js.modules.email_subscription.${
      this.state.subscribed ? 'Subscribed' : 'Subscribe'
    }`;
  }

  submitAttrs() {
    return this.state.subscribed ? { disabled: 'disabled' } : {};
  }

  getLoadingClass() {
    return this.state.showLoading ? 'loading' : '';
  }

  handleCheckboxClick() {
    const { state: newState } = this;
    const { areTermsAccepted } = this.state;

    newState.areTermsAccepted = !areTermsAccepted;

    if (this.state.errors.terms) {
      newState.errors.terms = areTermsAccepted;
    }

    this.setState(newState);
  }

  render() {
    const { csrfToken, routes } = this.props;

    return h(
      'form.email-subscription-form',
      {
        onSubmit: event => this.submit(event),
        novalidate: 'novalidate',
      },
      h('input', { type: 'hidden', name: '_csrf', value: csrfToken }),
      this.state.errors.email
        ? h(
            Translate,
            {
              tag: 'div',
              attrs: { class: 'input-error' },
            },
            'js.modules.email_subscription.EmailInputError'
          )
        : null,
      h(WithI18n, {}, i18n =>
        h('input', {
          placeholder: i18n.t('js.modules.email_subscription.Email'),
          'aria-label': i18n.t('js.modules.email_subscription.Email'),
          type: 'email',
          'data-bhc': 'input:email',
          onKeyUp: event => this.keyUpHandler(event),
        })
      ),
      h(
        Translate,
        {
          tag: 'button',
          attrs: {
            class: `button btn btn-invert ${this.getLoadingClass()}`,
            type: 'submit',
            'data-bhc': 'input:submit',
            ...this.submitAttrs(),
          },
        },
        this.getCTAText()
      ),
      this.state.errors.terms &&
        h(
          Translate,
          {
            tag: 'div',
            attrs: { class: 'input-error' },
          },
          'js.modules.email_subscription.CheckboxError'
        ),
      h(
        '.container-bottom-form',
        h('input', {
          type: 'checkbox',
          onClick: () => this.handleCheckboxClick(),
          checked: this.state.areTermsAccepted,
          id: 'terms-checkbox',
        }),
        h(
          Translate,
          {
            tag: 'label',
            attrs: {
              class: 'terms-checkbox-label',
              for: 'terms-checkbox',
            },
            0: h(
              Translate,
              {
                tag: 'a',
                attrs: { class: 'terms-of-use', href: routes.terms },
              },
              'js.modules.footer.TermsLinkText'
            ),
            1: h(
              Translate,
              {
                tag: 'a',
                attrs: {
                  class: 'privacy-statement',
                  href: routes.privacy,
                },
              },
              'js.modules.email_subscription.Privacy'
            ),
          },
          'js.modules.email_subscription.Checkbox'
        )
      ),
      this.state.errors.subscription &&
        h(
          Translate,
          {
            attrs: { class: 'email-subscription-error' },
          },
          'js.modules.email_subscription.Error'
        )
    );
  }
}

module.exports = hydrate('EmailSubscriptionForm', EmailSubscriptionForm);
